import ApiService from '../api.service'
import { TokenService } from '@/services/storage.service'

const ItemClassService = {
    getItemClasses: async () => {
        const url = `/api/ItemClass/GetItemClasses`

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    showHideItemClassInWebQuote: async (payload) => {
        const url = `/api/ItemClass/ShowHideItemClassInWebQuote?id=` + payload

        const requestData = {
            method: 'post',
            url: url,
            data: {},
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

}

export default ItemClassService